import { render, staticRenderFns } from "./CopyStakeUserBlacklistConfirmation.vue?vue&type=template&id=43bd973e&scoped=true&lang=pug"
import script from "./CopyStakeUserBlacklistConfirmation.vue?vue&type=script&lang=ts"
export * from "./CopyStakeUserBlacklistConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeUserBlacklistConfirmation.vue?vue&type=style&index=0&id=43bd973e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bd973e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
